import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name ev-charger
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMTNoMmEyIDIgMCAwIDEgMiAydjJhMiAyIDAgMCAwIDQgMHYtNi45OThhMiAyIDAgMCAwLS41OS0xLjQyTDE4IDUiIC8+CiAgPHBhdGggZD0iTTE0IDIxVjVhMiAyIDAgMCAwLTItMkg1YTIgMiAwIDAgMC0yIDJ2MTYiIC8+CiAgPHBhdGggZD0iTTIgMjFoMTMiIC8+CiAgPHBhdGggZD0iTTMgN2gxMSIgLz4KICA8cGF0aCBkPSJtOSAxMS0yIDNoM2wtMiAzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/ev-charger
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const EvCharger: IconNode = [
  ['path', { d: 'M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 4 0v-6.998a2 2 0 0 0-.59-1.42L18 5' }],
  ['path', { d: 'M14 21V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16' }],
  ['path', { d: 'M2 21h13' }],
  ['path', { d: 'M3 7h11' }],
  ['path', { d: 'm9 11-2 3h3l-2 3' }],
];

export default EvCharger;
